import React from 'react'
import { useParams } from 'react-router-dom'

import EditOrderForm from '@components/order/EditOrderForm'
import { Button, Panel, SelectPicker } from 'rsuite'
import { ORDER_STATUS_ASSEMBLY_IN_PROGRESS, ORDER_STATUS_COMPLETED, ORDER_STATUS_PLACED, ORDER_STATUS_WAITING_FOR_COURIER } from '@@partner:config/order-status-codes'

const data = [
  {
    value: ORDER_STATUS_PLACED,
    label: 'Создан'
  },
  {
    value: ORDER_STATUS_ASSEMBLY_IN_PROGRESS,
    label: 'Собирается'
  },
  {
    value: ORDER_STATUS_WAITING_FOR_COURIER,
    label: 'Ожидает курьера'
  },
  {
    value: ORDER_STATUS_COMPLETED,
    label: 'Выполнен'
  }
]

export default function MakeOrderPage () {
  const { orderId } = useParams<any>()

  return (
    <div className="MakeOrderPage">
      <h1 className="u-heading">Редактирование заказа #{orderId}</h1>
      <div style={{ paddingLeft: '10px', display: 'inline-block' }}><SelectPicker data={data} placeholder="Создан" /></div>
      <div style={{ paddingLeft: '10px', display: 'inline-block' }}><Button color="red">Отменить</Button></div>
      <Panel shaded>
        <EditOrderForm orderId={orderId} />
      </Panel>
    </div>
  )
}
